import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import { FiAward } from "react-icons/fi";
import { Section, Wrapper, SectionHead } from "../SectionHead";
import EducationCard from "../Cards/EducationCard";
import { fadeUp, viewportOnce } from "../../utils/motion";
import { education, certifications } from "../../data/constants";

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
`;

const SubHead = styled.h3`
  font-family: "Space Grotesk", sans-serif;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.text_muted};
  margin: 64px 0 22px;
`;

const CertGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
  gap: 16px;
`;

const CertCard = styled(motion.div)`
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 18px 20px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.035);
  border: 1px solid rgba(255, 255, 255, 0.08);
  transition: transform 0.3s ease, border-color 0.3s ease;

  &:hover {
    transform: translateY(-4px);
    border-color: rgba(34, 211, 238, 0.4);
  }
`;

const CertIcon = styled.div`
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.gradient};
  color: #050507;
  font-size: 17px;
`;

const CertBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

const CertTitle = styled.div`
  font-size: 13.5px;
  font-weight: 600;
  color: ${({ theme }) => theme.text_primary};
  line-height: 1.35;
`;

const CertMeta = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.text_muted};
`;

const Education = () => {
  return (
    <Section id="education" style={{ scrollMarginTop: 96 }}>
      <Wrapper>
        <SectionHead
          eyebrow="Education & Credentials"
          title="School, and the certifications I've added since."
          subtitle="A Bachelor's in progress, a diploma in accounting, and the certifications behind my infrastructure and security work."
        />

        <Grid>
          {education.map((edu, i) => (
            <motion.div
              key={edu.id}
              variants={fadeUp}
              initial="hidden"
              whileInView="visible"
              viewport={viewportOnce}
              custom={i}
            >
              <EducationCard education={edu} />
            </motion.div>
          ))}
        </Grid>

        <SubHead>Certifications</SubHead>
        <CertGrid>
          {certifications.map((cert, i) => (
            <CertCard
              key={cert.id}
              variants={fadeUp}
              initial="hidden"
              whileInView="visible"
              viewport={viewportOnce}
              custom={i}
            >
              <CertIcon>
                <FiAward />
              </CertIcon>
              <CertBody>
                <CertTitle>{cert.title}</CertTitle>
                <CertMeta>
                  {cert.issuer} &middot; {cert.year}
                </CertMeta>
              </CertBody>
            </CertCard>
          ))}
        </CertGrid>
      </Wrapper>
    </Section>
  );
};

export default Education;
